"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgConfiguration(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm14.8323 3.58633 1.09317-2.88574-.69566-.69659-2.7826 1.09459-.4969 1.49263-5.56522 5.5725a1.64227 1.64227 0 0 0 -1.98757.29852l-3.87578 3.88083a1.62734 1.62734 0 0 0 0 2.3882l.69565.69656a1.62236 1.62236 0 0 0 2.38509 0l3.87578-3.88083a1.83535 1.83535 0 0 0 .29814-1.99017l5.56522-5.57247m-9.83851 3.88083.19875-.199a2.91475 2.91475 0 0 1 1.8882-.69655 1.25912 1.25912 0 0 1 .59628.0995l1.59006-1.59214a4.079 4.079 0 0 0 -2.18634-5.17444 4.26761 4.26761 0 0 0 -2.48447-.199l2.882 2.88574-2.98138 2.98523-2.88199-2.88574a3.987 3.987 0 0 0 2.882 4.7764h.4969m6.95652.398-1.59007 1.59217a2.844 2.844 0 0 1 0 1.29361l4.47205 4.47787a1.38085 1.38085 0 0 0 1.88819 0l.39752-.398a1.38532 1.38532 0 0 0 0-1.89066' })));
}
exports.default = SvgConfiguration;
